module.exports = __webpack_public_path__ + "static/img/logo.c51a4c66.svg";